<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-close-bold`]" width="1em" height="1em" v-bind="$attrs"><path d="M11.0273 3.55845C11.4177 3.168 12.0508 3.16809 12.4413 3.55845C12.8318 3.94898 12.8318 4.582 12.4413 4.97251L9.41397 7.99985L12.4413 11.0272C12.8318 11.4177 12.8317 12.0507 12.4413 12.4413C12.0508 12.8315 11.4177 12.8317 11.0273 12.4413L7.99991 9.41392L4.97257 12.4413C4.58213 12.8316 3.94903 12.8315 3.5585 12.4413C3.16816 12.0507 3.16806 11.4177 3.5585 11.0272L6.58585 7.99985L3.5585 4.97251C3.16799 4.582 3.168 3.94898 3.5585 3.55845C3.94903 3.16805 4.58207 3.16799 4.97257 3.55845L7.99991 6.58579L11.0273 3.55845Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineCloseBold',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
